export * from './post-konstante.component';
export * from './post-konstante.component.module';